// extracted by mini-css-extract-plugin
export default {"tabSwitchWrapper":"style_tabSwitchWrapper__4cl2q","tabItem":"style_tabItem__a6dqE","tabIndicator":"style_tabIndicator__5mAbG"};